import { LoadType } from '@care-portals/api-interfaces';
import { createAction, props } from '@ngrx/store';
import { InvoiceEntity } from './invoice.models';

// export const loadInvoice = createAction(
//   '[Invoice] Load Invoice',
//   props<{ loadType: LoadType; customerId: string }>()
// );

export const loadInvoiceFromEmail = createAction(
  '[Invoice] Load Invoice',
  props<{ loadType: LoadType; email: string }>()
);

export const loadInvoiceSuccess = createAction(
  '[Invoice] Load Invoice Success',
  props<{ invoice: InvoiceEntity[]; loadType: LoadType }>()
);

export const loadInvoiceFailure = createAction(
  '[Invoice] Load Invoice Failure',
  props<{ error: any }>()
);

export const resetInvoices = createAction('[Invoice] Reset Invoices');
